export const BoxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  // marginTop: '-12px',
}

export const TextStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'Roboto',
  fontWeight: '400',
  letterSpacing: '0.15px',
  color: '#1F4266',
}

export const TextLoadingStyle = {
  marginLeft: 1,
  fontSize: '14px',
  lineHeight: '22px',
}

export const TextErrorStyle = {
  marginLeft: 1,
  fontSize: '14px',
  lineHeight: '22px',
  color: '#F23D3D',
}

export const DeleteIconButtonStyle = {
  padding: '4px',
}

export const DeleteIconStyle = {
  color: '#DADADA',
  fontSize: '16px',
}

export const CancelIconStyle = {
  width: '14px',
  height: '14px',
  color: '#F23D3D',
}

export const LoadingIconStyle = {
  width: '14px',
  height: '14px',
  color: '#1890FF',
}
